import {SettingsParamsType} from '../../types/createStylesParams'

import {displaySettingsParams, DisplaySettingsParams} from './Settings/Tabs/Display/settingsParams'
import {
  experiencesSettingsParams,
  ExperiencesSettingsParams,
} from './Settings/Tabs/Experiences/settingsParams'
import {textsSettingsParams, TextsSettingsParams} from './Settings/Tabs/Texts/settingsParams'

export type SettingsParams = DisplaySettingsParams & TextsSettingsParams & ExperiencesSettingsParams

export const settingsParams: SettingsParamsType<SettingsParams> = {
  ...displaySettingsParams,
  ...textsSettingsParams,
  ...experiencesSettingsParams,
}

export default settingsParams
